// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { useThemeId } from '@tectonics/prs/merchant';

import payingWithEbanxSrc from './paying-with-ebanx.svg';

export function DisplayPayingWithEbanx(): Node {
  const themeId = useThemeId();
  return (themeId !== 'default' &&
    <Wrapper>
      <Logo src={payingWithEbanxSrc} alt="pagando via EBANX"/>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-bottom-right-radius: ${props => props.theme.radius};
  background-color: ${props => props.theme.colors.gray(96)};
  padding: 12px;
`;

const Logo = styled.img`
  display: block;
  height: 50px;
  margin: auto;
`;
